import * as actionTypes from 'constants/actionTypes';

const init = false;
export default function timerReducer(state = init, action) {
    switch (action.type) {
    case actionTypes.START_TIMER:
        return action;
    case actionTypes.END_TIMER:
        return action;
    case actionTypes.CLEAR_TIMER:
        return action;
    default:
        return state;
    }
}
